import styled from 'styled-components'

export const Wrapper = styled.div<{ $show: boolean }>`
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transition-duration: inherit;
  display: inherit;
  justify-content: inherit;
  align-items: inherit;
  flex-direction: inherit;
`
